import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from 'src/containers/_loading';
import { ThePermission } from '../ThePermission';
import { helps } from 'src/_helpers';
import { docActions } from 'src/_actions';
import DocCategoriesForm from 'src/views/docs/DocCategoriesForm';


class DocsCategoriesFormContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            category: {},
            form_header: "Thêm Nhóm Văn Bản Mới",
            action_status: 'add',
        }
    }

    componentDidMount() {
        this.getCategories().then(() => {
            this.getCategory();
        });
    }

    getCategory() {
        let cat_id = this.props.match.params.id;
        const categories = this.props.categories;
        if (cat_id) {
            let category = categories.filter((_category) => {
                return _category.id === cat_id;
            });
            this.setState({ form_header: "Chỉnh Sửa Thông Tin Nhóm Văn Bản: " + category[0].name, action_status: 'edit', category: category[0] });
        }
    }

    async getCategories() {
        const docs = this.props.docs;
        if (!docs) await this.props.getAllCat();
    }

    handleSubmit = (category) => {
        let cat_id = this.props.match.params.id;
        var url = '/docs/categories';
        if (helps.isEmpty(cat_id)) {
            this.props.addCat(category);
        } else {
            this.props.updateCat(category);
        }
        this.props.history.push(url);
    }

    render() {
        if (this.props.loading) {
            return (
                <Loading></Loading>
            );
        }
        let cat_id = this.props.match.params.id;
        const { category } = this.state;
        if (!helps.isEmpty(cat_id) && helps.isEmpty(category)) return (<Loading></Loading>);

        return (
            <ThePermission {... this.props} component="docs" action="edit">
                <DocCategoriesForm
                    {... this.props}
                    doc={this.state.doc}
                    form_header={this.state.form_header}
                    action_status={this.state.action_status}
                    handleSubmit={this.handleSubmit}
                />
            </ThePermission>
        );
    }
}
function mapStateToProps(state) {
    const { loading, docs } = state.docReducer;
    const { user } = state.authentication;
    return { loading, docs, user };
}

const actionCreators = {
    getAllCat: docActions.getAllCat,
    addCat: docActions.addCat,
    updateCat: docActions.updateCat,
};
const connectedFormContainer = connect(mapStateToProps, actionCreators)(DocsCategoriesFormContainer);
export { connectedFormContainer as DocsCategoriesFormContainer };